export default function Spinner() {
  return (
    <div className="flex justify-center items-center">
      <div className="animate-spin rounded-full mt-60 h-32 w-32 border-b-4 border-gray-500"></div>
    </div>
  );
}
